export default "__VITE_ASSET__BTZ_m$f2__"